import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FINANCE_MODELING_INDEX } from '../../../router/routes';
import Classifier from '../../../enums/classifier';
import Title from '../../../components/common/title';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
  useTab,
} from '../../../components/common/tabs/tab-container';
import InfoBlock from '../../../components/common/info-block';
import DownloadsList from './list';

export default function ProductionModeling() {
  const { t } = useTranslation();
  const [currentTab, setTab] = useTab(FINANCE_MODELING_INDEX, [
    'type',
    'farmId',
  ]);

  const shortText = (
    <Trans
      i18nKey="pages.finance.modeling.description.short"
      components={{ 1: <br /> }}
    />
  );
  const longText = (
    <Trans
      i18nKey="pages.finance.modeling.description.long"
      components={{ 1: <br />, 2: <ul />, 3: <li /> }}
    />
  );

  return (
    <>
      <Title title={t('pages.finance.modeling.title')} />

      <InfoBlock text={longText} short={shortText} />

      <TabContainer
        selectedTabKey={currentTab}
        setTab={setTab}
        tabNavigation={
          <TabNavigation>
            <TabLink tabKey={Classifier.CROP_PRODUCTION_MODELS}>
              {t('pages.finance.modeling.types.crop')}
            </TabLink>
            <TabLink tabKey={Classifier.LIVESTOCK_PRODUCTION_MODELS}>
              {t('pages.finance.modeling.types.livestock')}
            </TabLink>
          </TabNavigation>
        }
        tabContents={
          <TabContents>
            <Tab tabKey={Classifier.CROP_PRODUCTION_MODELS}>
              <DownloadsList />
            </Tab>
            <Tab tabKey={Classifier.LIVESTOCK_PRODUCTION_MODELS}>
              <DownloadsList />
            </Tab>
          </TabContents>
        }
      />
    </>
  );
}
